/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'

export const testimonialsData = [
    {
        id: 1,
        name: 'Jeremiah Ekow Melfah',
        title: 'Software Engineer',
        text: "I have worked with Kareem on different projects and he is astounding in all project deliveries. I experienced how dedicated Kareem is when working with him on different projects and I am always impressed with his professionalism during collaboration. Kareem is one of the best developers I have ever worked with and he is certainly a great asset to any team.",
        image: boy2
    },
    {
        id: 2,
        name: 'Shuhad Loofer',
        title: 'Software Developer',
        text: "I am grateful to have worked with Kareem as he assisted me as well as taught me a different perspective on how to view my code. He is bright, patient, and willing to help and code with anyone even if it is something he is not well-versed in.",
        image: boy2
    },
    {
        id: 3,
        name: 'Ahmed Nazir Musah',
        title: 'Full-Stack Developer',
        text: 'I had the pleasure of working with Kareem on our final capstone project at Microverse, and I can confidently say that he is one of the most talented and dedicated full-stack developers I have ever had the pleasure of working with. His strong analytical skills and attention to detail were instrumental in ensuring the successful delivery of our complex project.',
        image: boy2
    },
    {
        id: 4,
        name: 'Nurgul Kereikhan',
        title: 'Full-Stack Web Developer',
        text: "Kareem Wilson helped me complete my project he was like a professional he solved my problems in small time, he understands my problem without seeing Visual Studio isn't it wonderful? Dear companies if you take him into your company, you will save a lot of time.",
        image: girl1
    },
    {
        id: 5,
        name: 'Amine Ouassef',
        title: 'Full-Stack Developer',
        text: "Kareem is one of the brightest team leaders, we worked closely together for a week on a technical project, and he is a detail-oriented person who motivates all team members to give their best and work towards perfection, his team-leading capabilities are beyond fantastic which helped the team to establish harmony and unity, I highly recommend Kareem!",
        image: boy2
    },
    {
        id: 6,
        name: 'Adnan Is-haq',
        title: 'Software Artist',
        text: 'I\'ve worked with Kareem and I can tell how passionate he is about software development and also his obsession with making his work as perfect as possible, he was one of my best team-mates, filled with team spirit and positivity.',
        image: boy2
    },
]

